'use strict';

function wrapNamespace(method) {
  return function(sugarNamespace, arg1, arg2) {
    sugarNamespace[method](arg1, arg2);
  };
}

module.exports = wrapNamespace;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/common/internal/wrapNamespace.js
// module id = 148
// module chunks = 1